export const REPORT_ID = 'stocks';
export const REPORT_APE_ID = 'stocks-ape';